import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import React, { useState, useEffect } from 'react';

const Polyline = (props) => {
  const { encodedPath, ...polylineOptions } = props;

  const map = useMap();
  const geometryLibrary = useMapsLibrary('geometry');
  const mapsLibrary = useMapsLibrary('maps');

  const [polyline, setPolyline] = useState(null);

  useEffect(() => {
    if (!mapsLibrary) return;

    setPolyline(new mapsLibrary.Polyline());
  }, [mapsLibrary]);

  useEffect(() => {
    if (!polyline) return;

    polyline.setOptions(polylineOptions);
  }, [polyline, polylineOptions]);

  useEffect(() => {
    if (!polyline || !geometryLibrary) return;

    let path;
    if (typeof encodedPath === 'string') {
      // Decode if it's an encoded string
      path = geometryLibrary.encoding.decodePath(encodedPath);
    } else if (Array.isArray(encodedPath)) {
      // Use as-is if it's already an array of { lat, lng }
      path = encodedPath;
    } else {
      console.error("Invalid encodedPath format:", encodedPath);
      return;
    }

    polyline.setPath(path);
  }, [polyline, encodedPath, geometryLibrary]);

  useEffect(() => {
    if (!map || !polyline) return;

    polyline.setMap(map);

    return () => polyline.setMap(null);
  }, [map, polyline]);

  return null;
};

export default Polyline;
